import { create } from "zustand";

export const usePermissionStore = create((set) => ({
  isCameraAllowed: null,
  setIsCameraAllowed: (value) => set({ isCameraAllowed: value }),
  setWebRequestKey: (key) => set({ webRequestKey: key }),
}));
